// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2wVLc","col":"CardReaderDesc_col__2QYAJ","label":"CardReaderDesc_label__3t1MD"};